export * from './HowToPlay';
export { default } from './HowToPlay';
